import { Dropdown, type DropdownItem } from "@/design-system/Dropdown/Dropdown";
import { useTranslation } from "@repo/shared/i18n";
import { ArrowDown } from "lucide-react";

/**
 * The sort, stated rather than labelled: the current order in muted text with
 * an arrow, opening the options. Sits at the right of a list's sort row.
 */
export const SortDropdown = ({
  items,
  selected,
  label,
  onChange,
  width = 180,
}: {
  items: DropdownItem[];
  selected: string;
  /** What the trigger reads; defaults to the selected item's label. */
  label?: string;
  onChange: (value: string) => void;
  width?: number;
}) => {
  const { t } = useTranslation(["players", "common"]);
  const triggerLabel =
    label ??
    items.find((item) => item.value === selected)?.label ??
    t("common:sortBy");
  return (
    <Dropdown
      variant="secondary"
      hideSearch
      align="end"
      width={width}
      items={items}
      selected={selected}
      placeholder={triggerLabel}
      onChange={(item) => onChange(item.value)}
      trigger={
        <button
          type="button"
          aria-label={t("toolbar.sortedBy", { sort: triggerLabel })}
          className="-mr-1 flex items-center gap-x-1 px-1 py-1.5 text-sm text-foreground-muted hover:text-foreground"
        >
          {triggerLabel}
          <ArrowDown className="size-4" />
        </button>
      }
    />
  );
};
